import React, { useEffect, useState, FC } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import * as types from "../gql/graphql";

import Grid from "@mui/material/Grid";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Card } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useParams } from 'react-router-dom';
import bcrypt from 'bcryptjs'

import { formatStudent } from '../utils/studentUtils';

import { SubmitErrorHandler, SubmitHandler, useForm, Controller } from 'react-hook-form';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
//import "primereact/resources/themes/md-light-indigo/theme.css";

import Purchases from './Purchases';
import StudentComplete from './StudentComplete';
import StudentAttendance from './StudentAttendance';
import MDBox from './MDBox/MDBoxRoot';
import MDBoxRoot from './MDBox/MDBoxRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';

import { SchoolTime } from '../utils/SchoolTime';
import { Password } from '@mui/icons-material';

const states = [
    { abbreviation: 'MD', name: 'Maryland' },
    { abbreviation: 'DC', name: 'District of Columbia' },
    { abbreviation: 'VA', name: 'Virginia' },
    { abbreviation: 'AL', name: 'Alabama' },
    { abbreviation: 'AK', name: 'Alaska' },
    { abbreviation: 'AZ', name: 'Arizona' },
    { abbreviation: 'AR', name: 'Arkansas' },
    { abbreviation: 'CA', name: 'California' },
    { abbreviation: 'CO', name: 'Colorado' },
    { abbreviation: 'CT', name: 'Connecticut' },
    { abbreviation: 'DE', name: 'Delaware' },
    { abbreviation: 'FL', name: 'Florida' },
    { abbreviation: 'GA', name: 'Georgia' },
    { abbreviation: 'HI', name: 'Hawaii' },
    { abbreviation: 'ID', name: 'Idaho' },
    { abbreviation: 'IL', name: 'Illinois' },
    { abbreviation: 'IN', name: 'Indiana' },
    { abbreviation: 'IA', name: 'Iowa' },
    { abbreviation: 'KS', name: 'Kansas' },
    { abbreviation: 'KY', name: 'Kentucky' },
    { abbreviation: 'LA', name: 'Louisiana' },
    { abbreviation: 'ME', name: 'Maine' },
    { abbreviation: 'MA', name: 'Massachusetts' },
    { abbreviation: 'MI', name: 'Michigan' },
    { abbreviation: 'MN', name: 'Minnesota' },
    { abbreviation: 'MS', name: 'Mississippi' },
    { abbreviation: 'MO', name: 'Missouri' },
    { abbreviation: 'MT', name: 'Montana' },
    { abbreviation: 'NE', name: 'Nebraska' },
    { abbreviation: 'NV', name: 'Nevada' },
    { abbreviation: 'NH', name: 'New Hampshire' },
    { abbreviation: 'NJ', name: 'New Jersey' },
    { abbreviation: 'NM', name: 'New Mexico' },
    { abbreviation: 'NY', name: 'New York' },
    { abbreviation: 'NC', name: 'North Carolina' },
    { abbreviation: 'ND', name: 'North Dakota' },
    { abbreviation: 'OH', name: 'Ohio' },
    { abbreviation: 'OK', name: 'Oklahoma' },
    { abbreviation: 'OR', name: 'Oregon' },
    { abbreviation: 'PA', name: 'Pennsylvania' },
    { abbreviation: 'RI', name: 'Rhode Island' },
    { abbreviation: 'SC', name: 'South Carolina' },
    { abbreviation: 'SD', name: 'South Dakota' },
    { abbreviation: 'TN', name: 'Tennessee' },
    { abbreviation: 'TX', name: 'Texas' },
    { abbreviation: 'UT', name: 'Utah' },
    { abbreviation: 'VT', name: 'Vermont' },
    { abbreviation: 'WA', name: 'Washington' },
    { abbreviation: 'WV', name: 'West Virginia' },
    { abbreviation: 'WI', name: 'Wisconsin' },
    { abbreviation: 'WY', name: 'Wyoming' },
];


const EditStudentDialog: FC = () => {
    // Your modal content and form for editing the row data

    // Is it needed?
    const handleEntered = () => {
        // The `autoFocus` is not used because, if used, the same Enter that saves
        // the cell triggers "No". Instead, we manually focus the "No" button once
        // the dialog is fully open.
        // noButtonRef.current?.focus();
    };

    const noButtonRef = React.useRef<HTMLButtonElement>(null);

    const getStudentQuery = gql(`
        query GetStudent($id:BigInt) {
            fs_studentsCollection(filter: {id: {eq: $id}}) {
                edges {
                    node {
                        nodeId
                        id
                        FirstName
                        LastName
                        Email
                        DOB
                        Height
                        Weight
                        AddrStreet
                        AddrTown
                        AddrZip
                        AddrState
                        Mobile
                        EnrolementDate
                        MedCondFlag
                        MedCondDescr
                        ExpLevel
                        HasEquipment
                        Notes
                        RegistrationState
                        RegisteredBy
                    }
                }
            }
        }`);

    const { studentId: studentId } = useParams();
    const { data, loading } = useQuery(getStudentQuery, { variables: { id: studentId }, fetchPolicy: 'network-only' });
    const [student, setStudent] = useState(null);

    const updateRegistrationState = (state:number) => {
        setStudent(prevStudent => ({
            ...prevStudent,
            RegistrationState: state  // Update only RegistrationState
          }));
    }

    useEffect(() => {
        if (data && data.fs_studentsCollection.edges.length > 0) {
            setStudent(formatStudent(data.fs_studentsCollection.edges[0]));
        }
    }, [data]);

    if (student) return <EditStudent student={student} updateRegistrationState={updateRegistrationState}/>;
    else return <>Loading</>;
}
export default EditStudentDialog;

export const NewStudentDialog: FC = () => {
    // ExpLevel: 0 - unknown, 1 - beginner, 2 - Intermediate, 3 - Advanced
    const student = { id: -1, ExpLevel: 0, EnrolementDate: SchoolTime.now().toISOLocal(), DOB: null };

    return <EditStudent student={student} updateRegistrationState={()=>{}}/>;
}

interface EditStudentProps {
    student: any;
    updateRegistrationState: (state:number) => void;
}


const EditStudent: FC<EditStudentProps> = (params) => {
    const { register,
        control,
        handleSubmit,
        clearErrors,
        setValue,
        reset,
        watch,
        formState: { errors } } = useForm<types.Fs_StudentsUpdateInput>({
            mode: "onBlur",
            defaultValues: params.student
        })

    const saveStudentDataQuery = gql(`
        mutation saveStudentDataQuery($st: fs_studentsUpdateInput!, $filter:fs_studentsFilter) {
            updatefs_studentsCollection(set: $st, filter: $filter) {
                affectedCount
                records {
                    nodeId
                    id
                    FirstName
                    LastName
                    Email
                    DOB
                    Height
                    Weight
                    AddrStreet
                    AddrTown
                    AddrZip
                    AddrState
                    Mobile
                    EnrolementDate
                    MedCondFlag
                    MedCondDescr
                    ExpLevel
                    HasEquipment
                    Notes
                    RegisteredBy
                }
            }
        }      
        `);

    const [saveStudentMutation, { data: saveData, loading: saveLoading, error: errorLoading }] = useMutation(saveStudentDataQuery, {
        refetchQueries: [
            //'GetStudents' // Query name
        ],
    });

    const addStudentDataQuery = gql(`
    mutation addStudentDataQuery($st: fs_studentsInsertInput!) {
        insertIntofs_studentsCollection(objects: [$st]) {
            affectedCount
            records {
                nodeId
                id
                FirstName
                LastName
                Email
                DOB
                Height
                Weight
                AddrStreet
                AddrTown
                AddrZip
                AddrState
                Mobile
                EnrolementDate
                MedCondFlag
                MedCondDescr
                ExpLevel
                HasEquipment
                Notes
                RegisteredBy
            }            
        }
    }      
    `);

    const [addStudentMutation, { data: add_data, loading: add_loading, error: add_error }] = useMutation(addStudentDataQuery, {
        refetchQueries: [
            //'GetStudents' // Query name
        ],
    });

    const navigate = useNavigate();

    const submit: SubmitHandler<types.Fs_StudentsUpdateInput> = async data => {

        // TODO: Data has all row fields, which is more than is defined in the input for saving - types.Fs_ClassesUpdateInput
        // Now filtering extra fields here. Need to find a better way to do that. 
        // Will using state management library help? Redux?
        function pickObjectKeys<T, K extends keyof T>(obj: T, keys: K[]) {
            let result = {} as Pick<T, K>
            for (const key of keys) {
                if (obj.hasOwnProperty(key) && (obj[key] !== undefined)) {
                    result[key] = obj[key]
                }
            }
            return result
        }

        // TODO: provide default value for listorder. Where?
        const filtered_data = pickObjectKeys(data, [
            'FirstName',
            'LastName',
            'Email',
            'DOB',
            'Height',
            'Weight',
            'AddrStreet',
            'AddrTown',
            'AddrZip',
            'AddrState',
            'Mobile',
            'EnrolementDate',
            'MedCondFlag',
            'MedCondDescr',
            'ExpLevel',
            'HasEquipment',
            'Notes',
            'RegisteredBy']);



        if (params.student.id == -1) {
            await addStudentMutation({ variables: { st: filtered_data } });
        }
        else {
            await saveStudentMutation({ variables: { filter: { nodeId: { eq: params.student.nodeId } }, st: filtered_data } });
        }
        navigate("../students");
    }

    const errorHandler: SubmitErrorHandler<types.Fs_StudentsUpdateInput> = data => {
    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };
    const [valueTab, setValueTab] = useState("1");

    useEffect(() => {
        if (params.student.id === -1) {
            setValueTab("3");
        }
    }, [params.student.id]);


    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
        setValueTab(newValue);
    };

    const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);
    const updateRegistrationStateTo10 = ():void => {
        params.updateRegistrationState(10);
    }

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '4px 4px 5px',
        border: '0px solid #ccc',
        borderRadius: '4px',
        textAlign: 'left',
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        fontSize: "0.875rem",
        color: "#344767",
        backgroundColor: "#f5f5f5",
    };
    return (
        <Grid container spacing={1}>
            <Grid item xs={11}>
                <Card>
                    <MDBoxRoot
                        component="main" px={4} py={4}
                        sx={{ flexGrow: 1, width: '100%' }}
                    >
                        <Toolbar />
                        <MDBoxRoot>
                            <MDBoxRoot px={0} py={2} textAlign="left">
                                <MDButtonRoot
                                    ownerState={{
                                        size: "medium",
                                        variant: "text",
                                        color: "info",
                                        textTransform: "uppercase",
                                    }}
                                    onClick={() => navigate("../students")}
                                    startIcon={<ArrowBackIcon />}
                                    sx={{ width: "max-content" }}>
                                    Return to Students List
                                </MDButtonRoot>
                            </MDBoxRoot>
                            <TabContext value={valueTab} >
                                <Tabs
                                    value={valueTab}
                                    onChange={handleChangeTab}
                                    textColor="primary"
                                >
                                    <Tab label="Purchases" value="1" disabled={params.student.id === -1} />
                                    <Tab label="Complete Schedule" value="2" disabled={params.student.id === -1} />
                                    <Tab label="Student Information" value="3" />
                                    <Tab label="Attendance History" value="4" disabled={params.student.id === -1} />
                                </Tabs>
                                <MDBoxRoot mt={2}>
                                    <MDTypographyRoot align="left">{params.student.FirstName} {params.student.LastName}
                                    </MDTypographyRoot>
                                </MDBoxRoot>
                                <TabPanel value="1">
                                    <Purchases StudentID={params.student.id} /></TabPanel>
                                <TabPanel value="2"><StudentComplete StudentID={params.student.id} /></TabPanel>
                                <TabPanel value="3">
                                    <Card sx={{ padding: "4px 16px 8px" }}>
                                        <MDBoxRoot
                                            ownerState={{
                                                variant: "contained",
                                                bgColor: "secondary",
                                                coloredShadow: "secondary",
                                            }}
                                            borderRadius={2}
                                            sx={{ display: 'flex', width: '100%' }}
                                            pb={1} px={2} mt={-1}>
                                            <MDTypographyRoot variant="h3" ownerState={{ color: "white" }}>
                                                Student Information
                                            </MDTypographyRoot>
                                        </MDBoxRoot>
                                        <MDBoxRoot style={{ width: "max-content" }}>
                                            <form onSubmit={handleSubmit(submit, errorHandler)} id="stForm">
                                                { /* TODO: Update validation rules for all fields. */}
                                                <MDBoxRoot display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>First Name</MDTypographyRoot>
                                                    <MDInput {...register('FirstName', { required: true })}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        aria-invalid={errors.FirstName ? true : false} />
                                                    {errors.FirstName && <MDBoxRoot><MDTypographyRoot variant="h6" px={1} ownerState={{ color: "error" }}>This field is required</MDTypographyRoot></MDBoxRoot>}

                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Last Name</MDTypographyRoot>
                                                    <MDInput {...register('LastName', { required: true })}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        aria-invalid={errors.FirstName ? true : false} />
                                                    {errors.LastName && <MDBoxRoot><MDTypographyRoot variant="h6" px={1} ownerState={{ color: "error" }}>This field is required</MDTypographyRoot></MDBoxRoot>}
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Email</MDTypographyRoot>
                                                    <MDInput {...register('Email', { required: true })}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth                                                        
                                                        aria-invalid={errors.Email ? true : false} />
                                                    {errors.Email && <MDBoxRoot><MDTypographyRoot variant="h6" px={1} ownerState={{ color: "error" }}>This field is required</MDTypographyRoot></MDBoxRoot>}
                                                </MDBoxRoot>
                                                <MDBoxRoot display="flex"
                                                    //justifyContent="flex-end"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">

                                                    {/* RegistrationState 0 - never signed in, 10 - signed in and set password, 20 - filled waiver, 30 - updated profile*/}
                                                    <MDBox display="flex" alignItems="center" gap="16px">
                                                        <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Password</MDTypographyRoot>
                                                        {params.student.RegistrationState >= 10 ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}                                                        
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => setShowChangePasswordDialog(true)}  // Add a reset handler
                                                            aria-label="Reset Password" 
                                                            disabled={params.student.id === -1}
                                                        >
                                                            <RestartAltIcon />
                                                        </IconButton>

                                                        <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Waiver</MDTypographyRoot>
                                                        {params.student.RegistrationState >= 20 ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                                                        <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Profile</MDTypographyRoot>
                                                        {params.student.RegistrationState >= 30 ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                                                    </MDBox>

                                                    <MDBox display="flex" alignItems="center" gap="8px">
                                                        <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Mobile number</MDTypographyRoot>
                                                        <MDInput {...register('Mobile')}
                                                            variant="standard"
                                                            size="medium"
                                                            aria-invalid={errors.Mobile ? true : false} />
                                                        {errors.Mobile && <span>Error</span>}
                                                    </MDBox>
                                                </MDBoxRoot>

                                                <MDBoxRoot display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">
                                                    <Controller
                                                        name="DOB"
                                                        control={control}
                                                        rules={{ required: 'Date of birth is required.' }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Date of birth</MDTypographyRoot>
                                                                <MDBoxRoot px={1} sx={{ width: "100%", textAlign: "left", padding: "14px" }}>

                                                                    <Calendar
                                                                        id={field.name}
                                                                        value={field.value}
                                                                        onChange={(e) => field.onChange(e.value)}
                                                                        mask="99/99/9999"
                                                                        dateFormat="mm/dd/yy"

                                                                        inputStyle={inputStyle}
                                                                        className={classNames('', { 'input-color': !fieldState.error })}
                                                                    />
                                                                    {getFormErrorMessage(field.name)}
                                                                </MDBoxRoot>
                                                            </>
                                                        )}
                                                    />
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Height</MDTypographyRoot>
                                                    <MDInput {...register('Height')}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        aria-invalid={errors.Height ? true : false} />
                                                    {errors.Height && <span>Error</span>}
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Weight</MDTypographyRoot>
                                                    <MDInput {...register('Weight', { valueAsNumber: true, /*minLength: 3, validate: isDuration*/ })}
                                                        variant="standard"
                                                        size="medium"
                                                        type='number'
                                                        fullWidth
                                                        aria-invalid={errors.Weight ? true : false} />
                                                    {errors.Weight && <span>Error</span>}
                                                </MDBoxRoot>
                                                <MDBoxRoot display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Street</MDTypographyRoot>
                                                    <MDInput {...register('AddrStreet')}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        aria-invalid={errors.AddrStreet ? true : false} />
                                                    {errors.AddrStreet && <span>Error</span>}
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Town</MDTypographyRoot>
                                                    <MDInput {...register('AddrTown')}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        aria-invalid={errors.AddrTown ? true : false} />
                                                    {errors.AddrTown && <span>Error</span>}
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Zip</MDTypographyRoot>
                                                    <MDInput {...register('AddrZip')}
                                                        variant="standard"
                                                        size="medium"
                                                        type='number'
                                                        fullWidth
                                                        aria-invalid={errors.AddrZip ? true : false} />
                                                    {errors.AddrZip && <span>Error</span>}
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>State</MDTypographyRoot>
                                                    <MDInput {...register('AddrState')}
                                                        select
                                                        variant="standard"
                                                        fullWidth
                                                        defaultValue={params.student.AddrState || "0"}
                                                    >
                                                        <MenuItem value="0">Select a state</MenuItem>
                                                        {states.map((state) => (
                                                            <MenuItem key={state.abbreviation} value={state.abbreviation}>
                                                                {state.name}
                                                            </MenuItem>
                                                        ))}
                                                    </MDInput>
                                                </MDBoxRoot>

                                                <MDBoxRoot display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Medical condition</MDTypographyRoot>
                                                    <Controller
                                                        name="MedCondFlag"
                                                        control={control}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Checkbox checked={value} onChange={onChange} size='medium' sx={{ width: "16px", border: "none" }} />
                                                        )}
                                                    />
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Medical condition description</MDTypographyRoot>
                                                    <MDInput
                                                        {...register('MedCondDescr')}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                    />
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Experience Level</MDTypographyRoot>
                                                    <MDInput {...register('ExpLevel')}
                                                        select
                                                        variant="standard"
                                                        fullWidth
                                                        defaultValue={params.student.ExpLevel || "0"}>
                                                        <MenuItem value="0">Select a level</MenuItem>
                                                        <MenuItem value="1">Beginner</MenuItem>
                                                        <MenuItem value="2">Experienced</MenuItem>
                                                        <MenuItem value="3">Intermediate</MenuItem>
                                                    </MDInput>
                                                </MDBoxRoot>
                                                <MDBoxRoot display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%">
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Has equipment</MDTypographyRoot>
                                                    <Controller
                                                        name="HasEquipment"
                                                        control={control}
                                                        render={({ field: { onChange, value } }) => (
                                                            <Checkbox checked={value} onChange={onChange} className='max-input-content' />
                                                        )}
                                                    />
                                                    <MDTypographyRoot variant="h5" px={1} ownerState={{ color: "dark" }}>Notes</MDTypographyRoot>
                                                    <MDInput
                                                        {...register('Notes')}
                                                        variant="standard"
                                                        size="medium"
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                    />
                                                </MDBoxRoot>
                                                <MDBoxRoot
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    flexDirection="row"
                                                    gap="16px"
                                                    pt={2}
                                                    pb={0.5}
                                                    px={2}
                                                    width="100%"
                                                >
                                                    <MDButtonRoot
                                                        ownerState={{
                                                            variant: "gradient",
                                                            color: "info",
                                                            textTransform: "none",
                                                        }}
                                                        endIcon={<SendIcon />}
                                                        type="submit">
                                                        Submit
                                                    </MDButtonRoot>
                                                    <MDButtonRoot
                                                        ownerState={{
                                                            variant: "gradient",
                                                            color: "dark",
                                                            textTransform: "none",
                                                        }}
                                                        onClick={() => navigate("../students")} >
                                                        Cancel
                                                    </MDButtonRoot>
                                                </MDBoxRoot>
                                            </form>
                                        </MDBoxRoot>
                                    </Card>
                                    {showChangePasswordDialog && <ChangePasswordDialog student={params.student} onClose={()=>setShowChangePasswordDialog(false)} onSuccess={updateRegistrationStateTo10}/>}
                                </TabPanel>
                                <TabPanel value="4">
                                    <StudentAttendance StudentID={params.student.id} />
                                </TabPanel>
                            </TabContext>
                        </MDBoxRoot>
                    </MDBoxRoot>
                </Card>
            </Grid>
        </Grid>
    )
}

const changePasswordQuery = gql(`
    mutation savePasswordQuery($pwd: String!, $filter: fs_studentsFilter, $regState: Int) {
        updatefs_studentsCollection(
            set: { 
                Password: $pwd, 
                RegistrationState: $regState,
                pwd_reset_flag: true 
            },
            filter: $filter
        ) {
            affectedCount
            records {
                nodeId
                id
            }
        }
    }
`);

// Don't show if student is not saved
interface ChangePasswordDialogProps {
    student: any;
    onClose: () => void;
    onSuccess: () => void;
}
const ChangePasswordDialog: FC<ChangePasswordDialogProps> = ({ student, onClose, onSuccess }) => {
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [changePasswordMutation, { loading, error }] = useMutation(changePasswordQuery);

    const isValidPassword = (pwd: string) => /^(?=.*\d)[A-Za-z\d]{6,}$/.test(pwd);

    const handleChangePassword = async () => {
        if (!isValidPassword(password)) {
            setErrorMsg('Password must be at least 6 characters long and contain at least one number.');
            return;
        }

        const trimmedPassword = password.trim();
      
        // Hash the password
        const hashedPassword = await bcrypt.hash(trimmedPassword, 10)

        const newRegState = student.RegistrationState === 0 ? 10 : student.RegistrationState;
        const updateRegState = newRegState !== student.RegistrationState;

        try {
            await changePasswordMutation({ 
                variables: { 
                    filter: { id: { eq: student.id } }, 
                    pwd: hashedPassword,
                    regState: newRegState
                } 
            });
            if (error) {
                setErrorMsg('Failed to change the password. Please try again.');
            } else {
                if(updateRegState) onSuccess();
                onClose();
            }
        } catch {
            setErrorMsg('An unexpected error occurred.');
        }
    };

    return (
        <Dialog maxWidth="sm" open={!loading} fullWidth>
            <MDTypographyRoot variant="h5" px={1} py={1}>
                Change Password
                <CloseIcon onClick={onClose} sx={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} />
            </MDTypographyRoot>
            <DialogContent dividers>
                <MDTypographyRoot variant="h4" px={1} ownerState={{ color: 'dark' }}>
                    New Password
                </MDTypographyRoot>
                <MDInput
                    variant="standard"
                    size="medium"
                    fullWidth
                    type="password"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setErrorMsg('');
                    }}
                    error={!!errorMsg}
                    placeholder="Enter new password"
                    aria-invalid={!!errorMsg}
                />
                {errorMsg && (
                    <MDTypographyRoot variant="body2" color="error" px={1} mt={1}>
                        {errorMsg}
                    </MDTypographyRoot>
                )}
            </DialogContent>
            <DialogActions>
                <MDButtonRoot
                    ownerState={{
                        variant: 'gradient',
                        color: 'info',
                        textTransform: 'none',
                    }}
                    size="medium"
                    onClick={handleChangePassword}
                >
                    Change Password
                </MDButtonRoot>
                <MDButtonRoot
                    ownerState={{
                        variant: 'gradient',
                        color: 'warning',
                        textTransform: 'none',
                    }}
                    size="medium"
                    onClick={onClose}
                >
                    Cancel
                </MDButtonRoot>
            </DialogActions>
        </Dialog>
    );
};